import React, { useEffect, useState } from "react";
import Routes from "../Constants/Routes";
import { Link } from "react-router-dom";

const docs = [
	{ title: "Deal Review", link: Routes.DEAL_MAKER() },
	{ title: "Document Review", link: Routes.DOCUMENT_REVIEW() },
	{ title: "Document Data Review", link: Routes.DOCUMENT_DATA_REVIEW() },
	{ title: "Document Sent", link: Routes.DOCUMENT_SENT() },
	{ title: "Verbal DnA", link: Routes.VERBAL_DNA() },
];

const credits = [
	{ title: "Precredit Review", link: Routes.PRE_CREDIT_REVIEW() },
	{ title: "Credit Review", link: Routes.CREDIT_REVIEW() },
	{ title: "Credit Adjudication", link: Routes.CREDIT_ADJUDICATION() },
];

const application = [
	{ title: "App Entry", link: Routes.APP_ENTRY() },
	{ title: "App Review", link: Routes.APP_REVIEW() },
];

const fundings = [
	{ title: "Funding Review", link: Routes.FUNDING_REVIEW() },
	{ title: "Funding Confirmation", link: Routes.FUNDED_CONFIRMATION() },
];

export default function QueueRoutes({ queue }) {
	const [microApps, setMicroApps] = useState([]);

	useEffect(() => {
		if (queue === "docs") setMicroApps(docs);
		else if (queue === "credits") setMicroApps(credits);
		else if (queue === "application") setMicroApps(application);
		else if (queue === "funding") setMicroApps(fundings);
		else setMicroApps([]);
	}, [queue]);

	return microApps.map((item, index) => (
		<Link key={index} to={item.link}>
			{item.title}
		</Link>
	));
}
